<template>
  <div>
    <NavBar />
    <v-img
      :src="require('@/assets/header/HomeHeader.jpg')"
      :height="this.$vuetify.breakpoint.mdAndUp ? 950 : 550"
    >
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-col>
            <h1
              class="text-center white--text"
              :style="
                this.$vuetify.breakpoint.mdAndUp ? 'font-size: 60px' : 'font-size: 40px'
              "
            >
              {{ $t("navbar.header") }}
            </h1>
          </v-col>
        </v-row>
      </v-container>

      <div v-if="this.$vuetify.breakpoint.mdAndUp">
        <section id="scrolldown" class="scrolldownbutton">
          <a @click="scrollourservicehomeid" class="font-weight-black">
            <span></span>
            {{ $t("navbar.scroll") }}
          </a>
        </section>
      </div>
    </v-img>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: "WebHeaderHome",
  components: {
    NavBar,
  },

  methods: {
    function() {
      "scrolldownbutton".on("click", function (e) {
        e.preventDefault();
        "html, body".animate({ scrollTop: this.attr("href").offset().top }, "slow");
        return false;
      });
    },

    scrollourservicehomeid() {
      const ourservicehomeid = document.getElementById("ourservicehomeid");
      ourservicehomeid.scrollIntoView({ behavior: "smooth" });
    },
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.scrolldownbutton a {
  position: absolute;
  bottom: 20px;
  left: 50%;
  z-index: 2;
  display: inline-block;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  color: #fff;
  font: normal 400 20px/1 "Roboto Slab", serif;
  letter-spacing: 0.1em;
  text-decoration: none;
  transition: opacity 0.3s;
}

.scrolldownbutton a:hover {
  opacity: 0.5;
}

#scrolldown a {
  padding-top: 70px;
}

#scrolldown a span {
  position: absolute;
  top: 0;
  left: 50%;
  width: 24px;
  height: 24px;
  margin-left: -12px;
  border-left: 1px solid #fff;
  border-bottom: 1px solid #fff;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: sdb05 1.5s infinite;
  animation: sdb05 1.5s infinite;
  box-sizing: border-box;
}

@-webkit-keyframes sdb05 {
  0% {
    -webkit-transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    -webkit-transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}

@keyframes sdb05 {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
</style>
